import { ActionIcon, Center, Paper } from '@mantine/core';
import { IconCaretDown } from '@tabler/icons-react';
import { MouseEventHandler } from 'react';

import classes from './../Sidebar.module.css';

interface ScrollDownProps {
  onScrollDown: () => void;
}

export function ScrollDown({ onScrollDown }: ScrollDownProps) {
  const onClick: MouseEventHandler = ev => {
    ev.stopPropagation();
    onScrollDown();
  };

  return (
    <Paper
      className={classes.scrollDown}
      onClick={onClick}
      bg="white"
      shadow="xs"
      py="2px"
      mb="5px"
      radius="xs"
    >
      <Center>
        <ActionIcon
          size={24}
          variant="outline"
          aria-label="jos"
        >
          <IconCaretDown
            onClick={onClick}
            style={{ width: '70%', height: '70%' }}
            stroke={1.5}
          />
        </ActionIcon>
      </Center>
    </Paper>
  );
}
